import { useAppContext } from '@faro/app-context';
import { useState } from 'react';
import { downloadPublishedAgenticArtifact } from './downloadPublishedAgenticArtifact';

export interface UseDownloadPublishedAgenticArtifactResult {
    download: () => Promise<void>;
    isPending: boolean;
}

/**
 * Triggers the browser save dialog for downloading the server generated HTML of a published report.
 */
export function useDownloadPublishedAgenticArtifact(
    spaceId: string,
    artifactId: string,
    version: number
): UseDownloadPublishedAgenticArtifactResult {
    const { showErrorNotification } = useAppContext();
    const [isPending, setIsPending] = useState(false);

    const download = async (): Promise<void> => {
        if (isPending) return;

        setIsPending(true);
        try {
            await downloadPublishedAgenticArtifact(spaceId, artifactId, version);
        } catch (error) {
            showErrorNotification('Failed to download report', error);
        } finally {
            setIsPending(false);
        }
    };

    return { download, isPending };
}
